import React from 'react';
import { useEffectOnce } from 'react-use';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Tab } from '../../../CommonComponents/OPL/Tab';
import { TabSlug } from '../../hooks/useRouteParams';

export interface Tab {
  slug: TabSlug;
  label: string;
  url: string | null;
}

interface Props {
  tabs: Tab[];
  selected: TabSlug;
  clientId: string;
}

export const Tabs: React.FC<Props> = ({ tabs, selected, clientId }) => {
  useEffectOnce(() => {
    ADV.util.Router.go2('OrionTrading', {
      clientId,
      tabSlug: tabs[0].slug,
    });
  });

  return (
    <Box display="flex" mb="24" borderBottom="1px solid" borderColor="neutral.200">
      {tabs.map(({ slug, label }) => (
        <Tab
          key={slug}
          selected={slug === selected}
          onClick={() => {
            ADV.util.Router.go2('OrionTrading', {
              clientId,
              tabSlug: slug,
            });
          }}
        >
          {label}
        </Tab>
      ))}
    </Box>
  );
};
